<div class="wifi-security-location-modal" id="wifi-sec-modal"
	attr.aria-label="{{ 'security.wifisecurity.locationmodal.title' | translate }}" role="dialog">
	<h1 role="none">{{ header | translate }}</h1>
	<p class="description">
		{{ description | translate }}
	</p>
	<ul>
		<li *ngFor="let package of packages">{{ package }}</li>
	</ul>
	<div class="d-flex">
		<div class="ml-0 mr-4 pl-0">
			<vtr-ui-button [linkId]="agreeButtonId" (onClick)="onOkClick()" [title]="OkText | translate"
				[label]="OkText | translate"></vtr-ui-button>
		</div>
		<div class="ml-0 mr-4 pl-0">
			<a (keydown)="keydownFn($event)" role="button" id="{{cancelButtonId}}" class="btn btn-default modal-button-cancel"
				(click)="onCancelClick()" tabindex="0">
				{{CancelText | translate}}
			</a>
		</div>
	</div>
	<div class="btn-modal-close">
		<vtr-ui-close-button [linkId]="closeButtonId"
			(clickClose)="onCancelClick()"></vtr-ui-close-button>
	</div>
</div>
